import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { AHText, Box, useTheme, AHIcon } from "arkh";
import { DateTime } from "luxon";
import { useWeekdays } from "../../../../../common/useWeekdays";
import { TeamScheduleListItemWeeklyRange_routineOccasion$key } from "./__generated__/TeamScheduleListItemWeeklyRange_routineOccasion.graphql";
import { capitalizeFirstLetter } from "../../../../../utils";

export function TeamScheduleListItemWeeklyRange(props: {
  routineOccasion: TeamScheduleListItemWeeklyRange_routineOccasion$key;
}) {
  const routineOccasion = useFragment(
    graphql`
      fragment TeamScheduleListItemWeeklyRange_routineOccasion on ScheduledOccasion {
        startAt
        deadlineAt
      }
    `,
    props.routineOccasion
  );

  const startWeekday = useMemo(
    () =>
      routineOccasion.startAt === null
        ? null
        : DateTime.fromISO(routineOccasion.startAt).weekday - 1,
    [routineOccasion.startAt]
  );
  const endWeekday = useMemo(
    () =>
      routineOccasion.deadlineAt === null
        ? null
        : DateTime.fromISO(routineOccasion.deadlineAt).weekday - 1,
    [routineOccasion.deadlineAt]
  );

  return (
    <TeamScheduleListItemWeeklyRangeComponent
      startWeekday={startWeekday}
      endWeekday={endWeekday}
    />
  );
}

export function TeamScheduleListItemWeeklyRangeComponent({
  startWeekday,
  endWeekday,
}: {
  startWeekday: number | null;
  endWeekday: number | null;
}) {
  const weekday = useWeekdays("short");
  const theme = useTheme();
  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceBottom="xxsmall"
    >
      {startWeekday !== null ? (
        <AHText color="text-washed" type="info-small">
          {capitalizeFirstLetter(weekday[startWeekday])}
        </AHText>
      ) : null}
      {startWeekday !== null &&
      endWeekday !== null &&
      startWeekday !== endWeekday ? (
        <Box spaceHorizontal="xxsmall">
          <AHIcon type="arrow-right" forceSize={12} customColor={theme["text-washed"]} />
        </Box>
      ) : null}
      {endWeekday !== null && startWeekday !== endWeekday ? (
        <AHText color="text-washed" type="info-small">
          {capitalizeFirstLetter(weekday[endWeekday])}
        </AHText>
      ) : null}
    </Box>
  );
}
